import React, { useState } from "react";
import ModalShell from "./ModalShell";

// Confirmation for the quick "×" on an assignee chip.
// `onConfirm()` must resolve to true on success so the modal can stay open on failure.
const ClearAssignmentModal = ({ candidateName, assigneeName, onConfirm, onClose }) => {
  const [saving, setSaving] = useState(false);

  const confirm = async () => {
    setSaving(true);
    const ok = await onConfirm();
    if (!ok) setSaving(false);
  };

  return (
    <ModalShell title="Remove assignment" maxWidth={420} onClose={onClose}>
      <div className="jv2-modal-body">
        <p style={{ textAlign: "left", fontSize: 13, color: "#525b66", margin: 0 }}>
          Remove <strong>{assigneeName || "the assignee"}</strong> from{" "}
          <strong>{candidateName || "this candidate"}</strong>? The candidate will become unassigned.
        </p>
      </div>
      <div className="jv2-modal-footer">
        <button className="jv2-modal-cancel" onClick={onClose}>Cancel</button>
        <button className="jv2-modal-confirm" disabled={saving} onClick={confirm}>
          {saving ? "Removing…" : "Remove"}
        </button>
      </div>
    </ModalShell>
  );
};

export default ClearAssignmentModal;
